import { RequestBase, RequestTypes } from './request-base';
import { UserAttribute } from './user-attribute';
import { SecurityGroup } from './security-group';
import { ProductLicense } from './license-rule';

export class UserAccountRequest extends RequestBase {
    SchemaId: string;
    SchemaName: string;
    UserName: string;
    Identification: string;
    Email: string;
    EmailConfirm: string;
    FirstName: string;
    SecondName: string;
    Surname: string;
    SecondSurname: string;
    ManualPassword: string;
    PasswordWay: PasswordWays;
    UserNameWay: UserNameWays;
    OrganizationLevelId: number;
    OrganizationLevel: string;
    StartDate: string;
    EndDate: string;
    HasEndTime: boolean = false;
    Attributes: UserAttribute[] = [];
    MemberOf: SecurityGroup[] = [];
    LicensesM365: ProductLicense[] = [];
    ProvisioningState?: SyncStates;
    LastSyncDate: string;
    LastErrorMessage: string;

    constructor() {
        super();
        this.Id = 0;
        this.PasswordWay = PasswordWays.Random;
        this.RequestType = RequestTypes.CreateUserAccount;
        this.LicensesM365 = [];
    }

    get Names(): string {
        return `${this.FirstName || ''} ${this.SecondName || ''} ${this.Surname || ''} ${this.SecondSurname || ''}`.trim();
    }

}



export enum PasswordWays {
    Manual,
    Random,
    Default
}


export enum UserNameWays {
    Manual,
    Automatic
}

export enum SyncStates {
    Pending = 0,
    Processing = 1,
    Executed = 2,
    Partial = 3,
    Failed = 4,
    Retrying = 5
}